/** Every word on the kiosk screens. Short, plain, readable from 2 m. */
export const strings = {
  revokedTitle: "This kiosk was removed",
  revokedBody: "Ask the owner to pair it again.",
  revokedStaff: "Staff sign-in",
  needsNetworkTitle: "Connect to the internet",
  needsNetworkBody: "This kiosk needs to go online once to finish setting up.",
  retry: "Try again",
  loadingLabel: "Getting the kiosk ready",
  emptyRosterTitle: "No members yet",
  emptyRosterBody: "Members appear here once they have a plan that works at this branch. Scans still go to the server.",
  switchCamera: "Switch camera",
  scanPrompt: "Hold your code up to the camera",
  cameraDeniedTitle: "Camera is blocked",
  cameraDeniedBody: "Allow camera access for this site in the browser settings, then reload this page.",
  cameraNoneTitle: "No camera found",
  cameraNoneBody: "This device has no camera that Helmr can use. Pair it as a wall kiosk instead.",
  cameraUnsupportedTitle: "Camera not available",
  cameraUnsupportedBody: "Open Helmr over a secure (https) connection to use the camera.",
  cameraFailedTitle: "Camera did not start",
  cameraFailedBody: "Close other apps that use the camera, then reload this page.",
  wallPrompt: "Scan with your phone camera or member app",
  wallExpiredTitle: "This code needs the internet",
  wallExpiredBody: "Connect the kiosk so it can refresh its code.",
  wallUnavailableTitle: "No code yet",
  wallUnavailableBody: "Connect the kiosk to the internet to get its code.",
  wallNoHostTitle: "No member web address",
  wallNoHostBody: "This gym's member web address is not set up yet, so there is no code to show. Check the brand in Settings.",
  staffButton: "Staff",
  queuedNote: "Saved. It syncs when the kiosk is back online.",
  statusOnline: "Online",
  statusOffline: "Offline",
  statusSyncError: "Sync problem",
  skewWarning: (minutes: number) => `This device's clock is ${minutes} minutes off. Fix the time or scans may be refused.`,
  rosterCount: (n: number) => `${n} members loaded`,
  queued: (n: number) => (n === 1 ? "1 scan waiting" : `${n} scans waiting`),
} as const;
